const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/tracking.ts';
export const ACTION_TYPE_PATAPP_TRACKING_AGREE = 'PATAPP_TRACKING_AGREED';
export const ACTION_TYPE_PATAPP_TRACKING_DISAGREE = 'PATAPP_TRACKING_DISAGREE';
export const ACTION_TYPE_PATAPP_TRACKING_FROM_STORAGE = 'PATAPP_TRACKING_FORM_STORAGE';
